"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAvailableFieldsWithTypes = exports.createConcentrationLimitMiscAvailableFieldProposals = exports.checkMultiLoanProductConcentrationCalcsErrors = exports.checkConcentrationCalcsErrors = exports.getNonFilterFieldReferencesFromConcentrationLimitConfig = exports.generateConcentrationLimitConfigFilterErrors = exports.ConcentrationLimitMiscAvailableFields = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const concentrationLimitValueEvaluator_1 = require("../concentrationLimitValueEvaluator");
const RequiredIntermediateFields_1 = require("../RequiredIntermediateFields");
// validate concentration calc configs.
// and reports errors.
const ConcentrationLimitMiscAvailableFieldConfigs = {
    loanProductId: {
        label: 'loanProductId',
        description: 'Loan product ID of Loan Product currently being configured',
        fieldType: 'string',
    },
    'eligibilityFields.isEligible': {
        label: 'eligibilityFields.isEligible',
        description: 'isEligible',
        fieldType: 'boolean',
    },
    'eligibilityFields.eligibleExposure': {
        label: 'eligibilityFields.eligibleExposure',
        description: 'Eligible Exposure',
        fieldType: 'float',
    },
    'concentrationLimitFields.eligibleExposureLessConcentrationLimitKickouts': {
        label: 'concentrationLimitFields.eligibleExposureLessConcentrationLimitKickouts',
        description: 'Eligible exposure less concentration limit kickouts',
        fieldType: 'float',
    },
};
exports.ConcentrationLimitMiscAvailableFields = Object.keys(ConcentrationLimitMiscAvailableFieldConfigs);
const generateAvailableFieldsForSelectedLoanProductIds = ({ loanProducts, loanProductIds, }) => {
    const availableFieldsForEachLoanProduct = _.map(loanProductIds, (loanProductId) => {
        const availableFieldsForLoanProduct = [
            ...exports.ConcentrationLimitMiscAvailableFields,
        ];
        const loanProductConfig = _.find(loanProducts, (loanProduct) => loanProduct.loanProductId === loanProductId);
        (0, common_1.finleyAssert)(loanProductConfig, 'loanProduct must exist on borrowingBaseMechanics for given loanProductId');
        const { _config_: { baseFieldConfigs, intermediateCalcConfigs }, } = loanProductConfig;
        baseFieldConfigs.forEach((baseFieldConfig) => {
            availableFieldsForLoanProduct.push(`baseFields.${baseFieldConfig.field}`);
        });
        intermediateCalcConfigs.forEach(({ field }) => {
            const prefix = RequiredIntermediateFields_1.RequiredIntermediateFieldNames.includes(field)
                ? 'requiredIntermediateFields'
                : 'dynamicIntermediateFields';
            availableFieldsForLoanProduct.push(`${prefix}.${field}`);
        });
        return _.uniq(availableFieldsForLoanProduct);
    });
    const sharedAvailableFieldsForLoanProducts = _.intersection(...availableFieldsForEachLoanProduct);
    return sharedAvailableFieldsForLoanProducts;
};
const generateConcentrationLimitConfigFilterErrors = ({ concentrationLimitConfig, availableFields, }) => {
    const errorMessages = [];
    // for pointer methods filters could be undefined
    const filters = concentrationLimitConfig.calculationConfig.config.filters || [];
    filters.forEach((filter) => {
        if (!availableFields.includes(filter.field)) {
            errorMessages.push(`Unknown field referenced ${filter.field} in ${concentrationLimitConfig.propertyKey}`);
        }
        if ('groupBy' in filter && !availableFields.includes(filter.groupBy)) {
            errorMessages.push(`Unknown field referenced ${filter.groupBy} in ${concentrationLimitConfig.propertyKey}`);
        }
    });
    return errorMessages;
};
exports.generateConcentrationLimitConfigFilterErrors = generateConcentrationLimitConfigFilterErrors;
const getNonFilterFieldReferencesFromConcentrationLimitConfig = ({ concentrationLimitConfig, }) => {
    const fieldReferences = [];
    switch (concentrationLimitConfig.calculationConfig.type) {
        case 'standard':
            // for standard, there are no field references outside filters.
            break;
        case 'weightedAverage':
            {
                // ensure that field referenced in weightedAverage is one of available fields
                const { field } = concentrationLimitConfig.calculationConfig.config;
                fieldReferences.push(field);
            }
            break;
        case 'exposureByGroup':
            // ensure that field referenced in exposureByGroup is one of available fields
            {
                const { groupingField, } = concentrationLimitConfig.calculationConfig.config;
                fieldReferences.push(groupingField);
            }
            break;
        case 'directInsert':
            // ensure that field referenced in directInsert is one of available fields
            {
                const { kickoutValueField, } = concentrationLimitConfig.calculationConfig.config;
                fieldReferences.push(kickoutValueField);
            }
            break;
        case 'resolvedPointer':
            break;
        default:
            (0, common_1.finleyAssertUnreachable)(concentrationLimitConfig.calculationConfig);
    }
    return fieldReferences;
};
exports.getNonFilterFieldReferencesFromConcentrationLimitConfig = getNonFilterFieldReferencesFromConcentrationLimitConfig;
const checkConcentrationCalcsErrors = (borrowingBaseMechanics) => {
    const errorMessages = [];
    const { loanProducts } = borrowingBaseMechanics;
    loanProducts.forEach((loanProductConfig) => {
        const { concentrationLimitConfigs, loanProductId } = loanProductConfig;
        const availableFields = generateAvailableFieldsForSelectedLoanProductIds({
            loanProducts,
            loanProductIds: [loanProductId],
        });
        concentrationLimitConfigs.forEach((concentrationLimitConfig) => {
            const filterErrors = (0, exports.generateConcentrationLimitConfigFilterErrors)({
                concentrationLimitConfig,
                availableFields,
            });
            errorMessages.push(...filterErrors);
            const nonFilterFieldReferences = (0, exports.getNonFilterFieldReferencesFromConcentrationLimitConfig)({
                concentrationLimitConfig,
            });
            nonFilterFieldReferences.forEach((fieldReference) => {
                if (!availableFields.includes(fieldReference)) {
                    errorMessages.push(`Unknown field referenced ${fieldReference} in ${concentrationLimitConfig.propertyKey}`);
                }
            });
            // limit config errors
            (0, concentrationLimitValueEvaluator_1.checkLimitConfigErrors)({
                concentrationLimitConfig,
            }).forEach((limitFormulaError) => {
                errorMessages.push(`Limit formula error in ${concentrationLimitConfig.propertyKey}: ${limitFormulaError.errorMessages.join(',')}`);
            });
        });
    });
    return {
        isValid: errorMessages.length === 0,
        errorMessages,
    };
};
exports.checkConcentrationCalcsErrors = checkConcentrationCalcsErrors;
const checkMultiLoanProductConcentrationCalcsErrors = (borrowingBaseMechanics) => {
    const errorMessages = [];
    const { loanProducts } = borrowingBaseMechanics;
    borrowingBaseMechanics.multiLoanProductConcentrationLimits.forEach((multiLPConcentrationLimit) => {
        const { loanProductIds } = multiLPConcentrationLimit;
        const availableFields = generateAvailableFieldsForSelectedLoanProductIds({
            loanProducts,
            loanProductIds,
        });
        const filterErrors = (0, exports.generateConcentrationLimitConfigFilterErrors)({
            concentrationLimitConfig: multiLPConcentrationLimit,
            availableFields,
        });
        errorMessages.push(...filterErrors);
    });
    return {
        isValid: errorMessages.length === 0,
        errorMessages,
    };
};
exports.checkMultiLoanProductConcentrationCalcsErrors = checkMultiLoanProductConcentrationCalcsErrors;
const createConcentrationLimitMiscAvailableFieldProposals = () => {
    return _.map(ConcentrationLimitMiscAvailableFieldConfigs, ({ label, description }) => ({
        label,
        documentation: description,
        insertText: label,
    }));
};
exports.createConcentrationLimitMiscAvailableFieldProposals = createConcentrationLimitMiscAvailableFieldProposals;
// given the loan product configs, returns a list of available fields
// that can be used with concentration calcs.
const getAvailableFieldsWithTypes = ({ loanProducts, loanProductIds, }) => {
    if (loanProductIds.length === 0) {
        // no loan products selected, so no available fields.
        return [];
    }
    const loanProductIdAndConfigs = loanProducts.map((loanProduct) => ({
        loanProductId: loanProduct.entity.id,
        _config_: loanProduct._config_,
    }));
    const availableFieldNames = generateAvailableFieldsForSelectedLoanProductIds({
        loanProducts: loanProductIdAndConfigs,
        loanProductIds,
    });
    // we need to find the type for each field. Since these field must exist in all loan products among (loanProductIds).
    // we will just look at 1st loan product to find the field type.
    const loanProductConfig = loanProducts.find((x) => x.entity.id === loanProductIds[0]);
    (0, common_1.finleyAssert)(loanProductConfig, `loanProduct must exist on borrowingBaseMechanics for given [loanProductId:${loanProductIds[0]}]`);
    const availableFields = availableFieldNames.map((fullyQualifiedFieldName) => {
        const prefix = fullyQualifiedFieldName.split('.')[0];
        if (prefix === 'baseFields') {
            const fieldType = loanProductConfig._config_.baseFieldConfigs.find((baseFieldConfig) => fullyQualifiedFieldName === `${prefix}.${baseFieldConfig.field}`)?.type;
            (0, common_1.finleyAssert)(fieldType, `baseFieldConfig must exist for ${fullyQualifiedFieldName} in ${loanProductConfig.entity.id}`);
            return {
                fullyQualifiedFieldName,
                fieldType,
            };
        }
        if (['requiredIntermediateFields', 'dynamicIntermediateFields'].includes(prefix)) {
            const fieldType = loanProductConfig._config_.intermediateCalcConfigs.find((intermediateCalcConfig) => fullyQualifiedFieldName ===
                `${prefix}.${intermediateCalcConfig.field}`)?.fieldType;
            (0, common_1.finleyAssert)(fieldType, `intermediateCalcConfig must exist for ${fullyQualifiedFieldName} in ${loanProductConfig.entity.id}`);
            return {
                fullyQualifiedFieldName,
                fieldType,
            };
        }
        // if fieldName is not baseField or intermediateCalcConfig, then it must be a misc field.
        (0, common_1.finleyAssert)(fullyQualifiedFieldName in ConcentrationLimitMiscAvailableFieldConfigs, `[${fullyQualifiedFieldName}] is not a valid field name`);
        const { fieldType } = ConcentrationLimitMiscAvailableFieldConfigs[fullyQualifiedFieldName];
        return {
            fullyQualifiedFieldName,
            fieldType,
        };
    });
    return availableFields;
};
exports.getAvailableFieldsWithTypes = getAvailableFieldsWithTypes;
//# sourceMappingURL=concentrationCalcValidation.js.map